import { Component, OnInit } from '@angular/core';
import { Company } from 'api/models';
import { AlertController, ViewController, NavParams, ToastController } from 'ionic-angular';
import { MeteorObservable } from 'meteor-rxjs';
import { APP_TITLE } from "../../services/config";
import { HttpService } from '../../services/httpService';
import { App } from "ionic-angular";

@Component({
  selector: 'add-company-user',
  templateUrl: 'add-company-user.html'
})

export class AddCompanyUserPage implements OnInit {
  employeeEmail: string;
  employeeName: string;
  employeeDescription: string;
  selectedCompany: Company;

  constructor(
    private _app: App,
    private navParams: NavParams,
    private alertCtrl: AlertController,
    private viewCtrl: ViewController,
    private toastCtrl: ToastController,
    public httpService: HttpService
  ) {
    this.selectedCompany = <Company>navParams.get("company");
    this.employeeName = '';
    this.employeeEmail = '';
  }

  ngOnInit() {
  }
  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
  }
  eventHandler(keyCode){
    if(keyCode==13){
      let activeElement = <HTMLElement>document.activeElement;
      activeElement && activeElement.blur && activeElement.blur();
    }
  }

  createMemberForm(): void {
    if (!this.selectedCompany) {
      this.showError('Error', 'No selected company, please try again.');
      this.viewCtrl.dismiss();
      return;
    }
    /*
    MeteorObservable.call('createCompanyMember', {
      companyId: this.selectedCompany._id,
      name: this.employeeName,
      email: this.employeeEmail
    }).subscribe({
      next: () => {
          this.viewCtrl.dismiss(true);
          this.showAddedUserToast(this.employeeName);
      },
      error: (e: Error) => {
        this.viewCtrl.dismiss(false).then(() => {
          this.showError('Error', 'There was a problem creating the user. Please try again.');
        });
      }
    });
    */

    this.httpService.MeteorCall(
      'createCompanyMember',
      {
        companyId: this.selectedCompany._id,
        name: this.employeeName,
        email: this.employeeEmail
      }
    ).then(() => {
      this.viewCtrl.dismiss(true);
      this.showAddedUserToast(this.employeeName);
    })
    .catch((e: Error) => {
      this.viewCtrl.dismiss(false).then(() => {
        this.showError('Error', 'There was a problem creating the user. Please try again.');
      });
    });
  }

  showAddedUserToast(userName: string) {
    let toast = this.toastCtrl.create({
      message: `${userName} has been added to the Company. They may take a few seconds to appear`,
      duration: 2500,
      position: 'bottom',
      dismissOnPageChange: true,
    });

    toast.present();
  }

  showError(title: string, message: string): void {
    const alert = this.alertCtrl.create({
      buttons: ['OK'],
      message,
      title: title || 'Oops',
    });

    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/add-company-user/add-company-user.ts